import { types } from './internet.type';

const initState = {
    isConnected: true,
}

export const internetReducer = (state = initState, action) => {
    switch (action.type) {
        case types.UPDATE_CONNECTION_STATUS: 
             return { ...state, isConnected: action.isConnected};
        default:
            return state;
    }
};